<template>
  <div class="successDialog">
    <van-popup v-model="showDialog" :close-on-click-overlay="false">
      <div class="content">
        <div class="header">
          <img v-if="code === 70402" src="../../../assets/images/attestation/tip-back.png" alt="" srcset="">
          <img v-else-if="code === 70416" src="../../../assets/images/attestation/certified-back.png" alt="" srcset="">
          <!-- <img v-else-if="code === 70408 || code === 70410" src="../../../assets/images/attestation/vehicleLicenseI-fail.png" alt="" srcset=""> -->
          <img v-else-if="code !== 0 && type === 2" src="../../../assets/images/attestation/businessLicense-fail.png" alt="" srcset="">
          <img v-else-if="code === 0 && type === 0" src="../../../assets/images/attestation/first-success-back.png" alt="" srcset="">
          <img v-else-if="code === 0 && type === 2" src="../../../assets/images/attestation/driver-success-back.png" alt="" srcset="">
          <img v-else-if="code === 0 && type === 1" src="../../../assets/images/attestation/second-success-back.png" alt="" srcset="">
          <img v-else src="../../../assets/images/attestation/vehicleLicenseI-fail.png" alt="" srcset="">
        </div>
        <div class="bottom">
          <div class="message" v-html="message"></div>
        </div>
        <div class="btn-box flex">
          <div class="tip-define-btn" @click="tipDefineBtn">{{ btnText }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { filterCodeMessage } from '../../../utils/attestation'
const againCode = [70403, 70405, 70407, 70408, 70409, 70410, 70412, 70413, 70414, 70419]
export default {
  props: {
    code: {
      type: Number,
      default () {
        return 0
      }
    },
    /**
     *
     *
     * 是否是第一步提交
    */
    type: {
      type: Number,
      default () {
        return 0
      }
    },
    errorMessage: {
      type: String,
      default () {
        return ''
      }
    },
    isGiveTicket: {
      type: Boolean,
      default () {
        return true
      }
    },
    /**
     *
     * 是否是个人认证过来去车主认证的
     *
    */
    isPerson: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data() {
    return {
      showDialog: false
    };
  },
  computed: {
    message() {
      if (this.code === 0 && this.type === 1 && this.isPerson) {
        // 如果是个人认证过来的车主认证，显示加票提示
        return '恭喜您已获得10票奖励'
      }
      if ((this.code === 0 && this.type === 2) || !this.isGiveTicket) {
        return ''
      } else {
        return filterCodeMessage(this.code) || this.errorMessage
      }
    },
    btnText() {
      return againCode.indexOf(this.code) >=0 ? '重新上传' : '确定'
    },
  },
  methods: {
    /**
     *
     * 显示弹框
    */
    showPopup() {
      this.showDialog = true
    },
    /**
     *
     *
     * 确定事件通知父组件
    */
    tipDefineBtn() {
      this.showDialog = false
      this.$emit('define')
    }
  }
};
</script>

<style scoped lang="scss">
.successDialog>:first-child {
  background-color: rgba(0,0,0,.4)
}
.successDialog>:nth-child(2){
  width: 80%;
  border-radius: 16px;
  top: 40%;
}
.successDialog {
  .content {
    .header {
      img {
        width: 100%;
      }
    }
    .bottom {
      padding: 20px 40px 30px;
      background-color: #ffffff;
      text-align: center;
      .message {
        color: #656565;
        font-size: 24px;
        line-height: 50px;
      }
    }
    .btn-box {
      justify-content: space-between;
      margin: 20px 80px 30px;
    }
    .tip-define-btn {
      flex: 1;
      background-color: #5572FC;
      border-radius: 4px;
      text-align: center;
      color: #ffffff;
      line-height: 80px;
      height: 80px;
      margin: 0 20px;
    }
  }
}
</style>
